import { useBunja } from 'bunja/react';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { authBunja } from '@flipster/features/src/shared/auth/state';
import { accountBunja } from '@flipster/r230522/original/account';

import { yourPositionsBunja } from '../../../state';
import { openPositionRowDataBunja } from './row-bunja';

/**
 * 열린 포지션 행 액션들이 클릭 시점에 읽는 공용 source 스냅샷.
 * 구독(useAtomValue)이 아니라 useAtomCallback이므로 소켓 tick에 리렌더를 만들지 않는다.
 *
 * CTA(useCtaSnapshot)와 행 액션 훅(use-open-position-row-actions)이 동일한 필드 조합을
 * 각자 구현하던 것을 한 곳으로 모아, 필드 추가/누락으로 인한 두 경로 간 불일치를 예방한다.
 * CTA 전용 필드(isOneWayMode)는 이 훅 위에 조합한다.
 */
export const useOpenPositionSnapshot = () => {
  const { positionAtom, instrumentAtom } = useBunja(openPositionRowDataBunja);
  const { v2AccountAtom } = useBunja(accountBunja);
  const { getMeAtom } = useBunja(authBunja);
  const { showAllSymbolAtom } = useBunja(yourPositionsBunja);

  return useAtomCallback(
    useCallback(
      (get) => ({
        position: get(positionAtom),
        instrument: get(instrumentAtom),
        account: get(v2AccountAtom),
        showAllSymbol: get(showAllSymbolAtom),
        user: get(getMeAtom).data,
      }),
      [positionAtom, instrumentAtom, v2AccountAtom, showAllSymbolAtom, getMeAtom],
    ),
  );
};
